import { Box, Select, Option, Typography, Stack, Input } from "@mui/joy";
import { Gauge, Wrench } from "lucide-react";

const SIZE_OPTIONS = ["4 inch", "5 inch"];

type ActionType = "R&R" | "Remove" | "Install" | "D&R";
const ACTION_OPTIONS: ActionType[] = ["R&R", "Remove", "Install", "D&R"];

interface IBathVentWithSize {
    sizeValue: string | null;
    onSizeChange: (value: string) => void;
    item: { actual?: number } | undefined;
    action: ActionType;
    onQtyChange: (value: number) => void;
    onActionChange: (action: ActionType) => void;
    loading?: boolean;
}

export function BathVentWithSize(props: IBathVentWithSize) {
    const { sizeValue, onSizeChange, item, action, onQtyChange, onActionChange, loading } = props;
    const selectedSize = sizeValue && SIZE_OPTIONS.includes(sizeValue) ? sizeValue : "4 inch";

    return (
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Bath Vent
            </Typography>
            <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                <Select
                    size="sm"
                    value={selectedSize}
                    onChange={(_e, val) => val && onSizeChange(val)}
                    disabled={loading}
                    startDecorator={<Gauge size={14} />}
                    slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
                    sx={{ minWidth: 110, flexShrink: 0 }}
                >
                    {SIZE_OPTIONS.map((opt) => (
                        <Option key={opt} value={opt}>
                            {opt}
                        </Option>
                    ))}
                </Select>
                <Input
                    size="sm"
                    type="number"
                    placeholder="0"
                    value={item?.actual || ""}
                    onChange={(e) => onQtyChange(Math.max(0, Number(e.target.value) || 0))}
                    disabled={loading}
                    slotProps={{ input: { min: 0 } }}
                    sx={{ flex: 1 }}
                />
                <Select
                    size="sm"
                    variant="outlined"
                    value={action}
                    onChange={(_e, val) => val && onActionChange(val as ActionType)}
                    disabled={loading}
                    slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
                    startDecorator={<Wrench size={14} />}
                    sx={{
                        minWidth: 100,
                        flexShrink: 0,
                        backgroundColor: "background.surface",
                    }}
                >
                    {ACTION_OPTIONS.map((opt) => (
                        <Option key={opt} value={opt}>
                            {opt}
                        </Option>
                    ))}
                </Select>
            </Stack>
        </Box>
    );
}
